function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgDislike = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M8.369 20.927a.2.2 0 01-.283.004l-.004-.004-.732-.752a1.95 1.95 0 01-.42-2.068l1.295-3.324-4.163.131a2 2 0 01-1.993-2.525l1.886-6.916a2 2 0 011.93-1.474h7.662a2 2 0 011.99 1.801l.805 8.048a.2.2 0 01-.126.206l-1.863.729-5.985 6.144zM17.533 14a.2.2 0 01-.198-.173l-1.197-8.696a.2.2 0 01.171-.225l.032-.002 3.843.092a.2.2 0 01.194.178l.956 8.604a.2.2 0 01-.177.221l-.022.001h-3.602zm.802-6.012a1 1 0 100-2 1 1 0 000 2z"
  }));
});
export default SvgDislike;